import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer
  } from "recharts";
  
  export default function DashboardChart({ data, blockFilter, fromMonth, toMonth }) {
  
    const COLORS = [
      "#4f46e5",
      "#22c55e",
      "#f59e0b",
      "#ef4444",
      "#06b6d4",
      "#8b5cf6",
      "#10b981",
      "#f97316",
    ];
  
    let chartData = [];
  
    /* ===============================
       ALL BLOCKS → BLOCK PERFORMANCE
    =============================== */
  
    if (!blockFilter) {
  
      const blockMap = {};
  
      data.forEach((row) => {
  
        if (!blockMap[row.block]) {
          blockMap[row.block] = 0;
        }
  
        blockMap[row.block] += Number(row.value);
  
      });
  
      chartData = Object.keys(blockMap).map((block) => ({
        name: block,
        value: blockMap[block],
      }));
  
    }
  
    /* ===============================
       BLOCK SELECTED → SCHEME PERFORMANCE
    =============================== */
  
    else {
  
      const schemeMap = {};
  
      data.forEach((row) => {
  
        if (!schemeMap[row.scheme]) {
          schemeMap[row.scheme] = 0;
        }
  
        schemeMap[row.scheme] += Number(row.value);
  
      });
  
      chartData = Object.keys(schemeMap).map((scheme) => ({
        name: scheme,
        value: schemeMap[scheme],
      }));
  
    }
  
    /* Sort descending for better visualization */
  
    chartData.sort((a, b) => b.value - a.value);
  
    /* Handle no data */
    const chartHeight = Math.max(350, chartData.length * 35);
    if (chartData.length === 0) {
  
      return (
        <div className="bg-white shadow rounded p-6 mt-8 text-center text-gray-500">
          No data available for selected filters
        </div>
      );
  
    }
  
    return (
  
      <div className="bg-white shadow rounded p-6 mt-8">
  
        {/* Header */}
  
        <div className="flex justify-between items-center mb-4">
  
          <h3 className="text-lg font-semibold text-indigo-700">
  
            {blockFilter
              ? `Scheme Performance - ${blockFilter}`
              : "Block Performance Overview"}
  
          </h3>
  
          <span className="text-sm text-gray-500">
  
            {fromMonth} → {toMonth}
  
          </span>
  
        </div>
  
        {/* Chart */}
  
        <ResponsiveContainer width="100%" height={chartHeight}>
  
          <PieChart>
  
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              outerRadius={130}
              label
            >
  
              {chartData.map((entry, index) => (
  
                <Cell
                  key={index}
                  fill={COLORS[index % COLORS.length]}
                />
  
              ))}
  
            </Pie>
  
            <Tooltip />
  
            <Legend />
  
          </PieChart>
  
        </ResponsiveContainer>
  
      </div>
  
    );
  
  }